import React from 'react'
import styled from 'styled-components'
import { customMedia } from '../../../common/customMedia'
import { Image } from '../../../common/Image'

export interface Props {
  imagePath: string
  storeName: string
  message: string
}

export const ManagerMessage = (props : Props) => {
  const { imagePath, storeName, message } = props

  return (
    <Container>
      <ImageWrapper>
        <Image path={imagePath} />
      </ImageWrapper>
      <Balloon>
        <BalloonContent>
          <StoreName>{storeName}</StoreName>
          <Message>{message}</Message>
        </BalloonContent>
      </Balloon>
    </Container>
  )
}

const Container = styled.div`
  ${customMedia.lessThan("medium")`
  `}
  ${customMedia.greaterThan("medium")`
    height: 450px;
  `}
  
  background-color: #00559F;
  position: relative;
`

const ImageWrapper = styled.div`
  ${customMedia.lessThan("medium")`
    height: 180px;
  `}
  ${customMedia.greaterThan("medium")`
    left: 100px;
    height: 80%;
    position: absolute;
    width: 45%;
    
    img {
      border-radius: 20px;
      height: 80% !important;
      object-fit: cover;
      object-position: 50% top !important;
    }
  `}
`

const Balloon = styled.div`
  ${customMedia.lessThan("medium")`
    border-top-right-radius: 20px;
    border-bottom-right-radius: 20px;
    margin-top: -10px;
    margin-right: 40px;

    :after, :before{
      border: solid transparent;
      content: '';
      height: 0;
      width: 0;
      pointer-events: none;
      position: absolute;
      bottom: 100%;
      left: 60%;
    }

    :after {
      border-color: rgba(255, 255, 255, 0);
      border-top-width: 16px;
      border-bottom-width: 16px;
      border-left-width: 6px;
      border-right-width: 6px;
      margin-left: -6px;
      border-bottom-color: #fff;
    }

    :before {
      border-color: rgba(0, 85, 159, 0);
      border-top-width: 21px;
      border-bottom-width: 21px;
      border-left-width: 8px;
      border-right-width: 8px;
      margin-left: -8px;
      margin-bottom: 2px;
      border-bottom-color: #00559F;
    }
  `}
  ${customMedia.greaterThan("medium")`
    border-radius: 20px;
    right: 100px;
    height: 300px;
    position: absolute;
    top: 93px;
    width: 45%;

    :after, :before{
      border: solid transparent;
      content: '';
      height: 0;
      width: 0;
      pointer-events: none;
      position: absolute;
      right: 100%;
      top: 30%;
    }
    :after{
      border-color: rgba(255, 255, 255, 0);
      border-top-width: 5px;
      border-bottom-width: 5px;
      border-left-width: 14px;
      border-right-width: 14px;
      margin-top: -5px;
      border-right-color: #fff;
    }
    :before{
      border-color: rgba(0, 85, 159, 0);
      border-top-width: 7px;
      border-bottom-width: 7px;
      border-left-width: 19px;
      border-right-width: 19px;
      margin-top: -7px;
      margin-right: 2px;
      border-right-color: #00559F;
    }
  `}

  background-color: #fff;
  border: 2px #00559F solid;
  position: relative;
  text-align: left;
`

const BalloonContent = styled.div`
  ${customMedia.lessThan("medium")`
    padding: 20px;
  `}
  ${customMedia.greaterThan("medium")`
    position: absolute;
    top: 50%;
    left: 50%;
    padding: 0 30px;
    transform: translateY(-50%) translateX(-50%);
    -webkit-transform: translateY(-50%) translateX(-50%);
    width: 100%;
  `}
`

const StoreName = styled.div`
  ${customMedia.lessThan("medium")`
    font-size: 1.6rem;
  `}
  ${customMedia.greaterThan("medium")`
    font-size: 2rem;
  `}

  color: #00559F;
  letter-spacing: 0.1em;
  font-weight: bold;
`

const Message = styled.div`
  ${customMedia.lessThan("medium")`
    font-size: 1.4rem;
    margin-top: 15px;
  `}
  ${customMedia.greaterThan("medium")`
    font-size: 1.6rem;
    letter-spacing: 0.04em;
    margin-top: 20px;
  `}

  color: #00559F;
`